export function executeBigSelection(kks: string[]): void {
  const envelope = {
    type: 'filter-applied',
    element_type_name: 'DDM__catchall',
    data: {
      filters:
        kks.length === 1
          ? [{ key: 'KKS', value: kks[0] }]
          : [{ key: 'KKS', values: kks }],
      settings: {
        type: 'structure',
        model_actions: {
          zoom: true,
          highlight: true,
        },
      },
    },
  };

  let isIframe = false;
  try {
    isIframe = window.self !== window.top;
  } catch (e) {
    isIframe = true;
  }

  if (isIframe) {
    console.log(`[DEV] executeBigSelection: ${JSON.stringify(envelope)}`);
    window.parent.postMessage(envelope, 'https://app.build-big.ch');
  }
}
